import { render, staticRenderFns } from "./ActiveNews.vue?vue&type=template&id=54034477&scoped=true"
import script from "./ActiveNews.vue?vue&type=script&lang=js"
export * from "./ActiveNews.vue?vue&type=script&lang=js"
import style0 from "./ActiveNews.vue?vue&type=style&index=0&id=54034477&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54034477",
  null
  
)

export default component.exports